import { coreTimelineGroupedSummaryGetAsyncSlice } from './get';

export const { requestGetCoreTimelineGroupedSummary, resetGetCoreTimelineGroupedSummary } =
	coreTimelineGroupedSummaryGetAsyncSlice.asyncActionCreators;
